import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./style.css";
import {
    Form,
    Input,
    Button,
    DatePicker,
    Table,
    Spin,
    Pagination,
} from "antd";
import API, { GAMING_HIS, GAMING_HIS_EXCEL } from "../../network/api";
import moment from "moment";
import "moment-timezone";
import { TEXT_DEF } from "../../constant/text";

const TEXT = {
    score: 'Số điểm nhận được',
    time: 'Thời gian',
    status: 'Trạng thái',
    vip: 'Cấp VIP'
}

const GamingHistoryList = () => {
    const [form] = Form.useForm();
    const [, forceUpdate] = useState({});
    const [dateFrom, setDateFrom] = useState();
    const [dateTo, setDateTo] = useState();
    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const locale = {
        emptyText: TEXT_DEF.text0035,
    };
    const [loading, setLoading] = useState(false);
    const usernameFilterLocal = localStorage.getItem("usernameFilter");
    const [dataFilter, setDataFilter] = useState();

    useEffect(() => {
        forceUpdate({});
        if (usernameFilterLocal) {
            setDataFilter(`username=${usernameFilterLocal}`);
            form.setFieldValue("usernameFilter", usernameFilterLocal);
            localStorage.removeItem("usernameFilter");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        getListData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, dataFilter]);

    const getListData = async () => {
        setLoading(true);
        const dataList1 = API.get(
            `${GAMING_HIS}?pageSize=10&page=${page}${dataFilter ? `&${dataFilter}` : ""}`
        );

        await Promise.all([dataList1])
            .then((response) => {
                const res = response[0].data.data.data;
                if (res) {
                    let dataCV = [];
                    res?.map((item) => {
                        const user = {
                            key: item?.id,
                            username: item?.username,
                            createdAt: item?.createdAt,
                            score: item?.score,
                            status: item.status ? "Thành công" : "Thất bại",
                            vipLevel: item?.vipLevel
                        };
                        dataCV.push(user);
                        return dataCV;
                        // dataUserCV = dataUserCV.sort((a, b) => (moment(a.createdAt).valueOf() - moment(b.createdAt).valueOf()))
                    });

                    setDataList(dataCV);
                    setTotalRecord(response[0].data?.data.total);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    const onChangePage = (page) => {
        setPage(page);
    };

    const showTotal = (total) => `Tổng cộng ${total} dữ liệu`;

    const onSearch = () => {
        let params = '';
        if (form.getFieldValue("usernameFilter"))
            params += `username=${form.getFieldValue("usernameFilter").trim().toLowerCase()}`;
        if (form.getFieldValue("userStatus"))
            params += params !== '' ? `&status=${form.getFieldValue("userStatus")}` : `status=${form.getFieldValue("userStatus")}`;
        if (dateFrom) {
            params += params !== '' ? `&fromDate=${moment(dateFrom).format("YYYY-MM-DD")}` : `fromDate=${moment(dateFrom).format("YYYY-MM-DD")}`;
        }
        if (dateTo) {
            params += params !== '' ? `&toDate=${moment(dateTo).format("YYYY-MM-DD")}` : `toDate=${moment(dateTo).format("YYYY-MM-DD")}`;
            params += !dateFrom ? `&fromDate=${moment('2025-07-15').format("YYYY-MM-DD")}` : '';
        }

        if (params !== '') {
            setDataFilter(params);
        } else {
            setDataFilter(null);
        }
    };

    const dataColums = [
        {
            title: "STT",
            align: "center",
            key: "order",
            render: (text, record, index) => (
                <span>{(page - 1) * 10 + (index + 1)}</span>
            ),
        },
        {
            title: TEXT_DEF.text0002,
            dataIndex: "username",
            key: "username",
        },
        {
            title: TEXT.vip,
            dataIndex: "vipLevel",
            key: "vipLevel",
        },
        {
            title: TEXT.score,
            key: "score",
            dataIndex: "score",
        },
        {
            title: 'Thời gian',
            key: "createdAt",
            render: (record) =>
                moment(record?.createdAt).utcOffset(7).format("DD-MM-YYYY HH:mm:ss"),
        },
        {
            title: TEXT.status,
            key: "status",
            dataIndex: "status",
        }
    ];

    const onChangeDate = (e, type) => {
        if (e) {
            if (type === "from") setDateFrom(moment(e.$d).startOf("day").format('yyyy-MM-DD'));
            else setDateTo(moment(e.$d).endOf("day").format('yyyy-MM-DD'));
        } else {
            if (type === "from") setDateFrom(null);
            else setDateTo(null);
        }
    };

    const handleDownloadExcel = async () => {
        await API.post(
            `${GAMING_HIS_EXCEL}?${dataFilter ? `&${dataFilter}` : ""}`,
            {},
            { responseType: 'blob' })
                .then(async (response) => {
                    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;

                    // Optional: lấy tên file từ response header nếu có
                    const disposition = response.headers.get('Content-Disposition');
                    let fileName = 'lich_su_choi_game.xlsx';
                    if (disposition && disposition.includes('filename=')) {
                        fileName = disposition.split('filename=')[1].replace(/"/g, '');
                    }

                    link.setAttribute('download', fileName);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                })
                .catch((error) => {
                    console.log(error);
                    setLoading(false);
                });
    };

    const renderHistory = () => {
        return (
            <>
                <div className="col-12">
                    <Form
                        form={form}
                        layout="inline"
                        autoComplete="off"
                        onFinish={() => onSearch()}
                    >
                        <div
                            className="col-12"
                            style={{ marginBottom: 15, display: "flex" }}
                        >
                            <div className="col-5">
                                <Form.Item name="usernameFilter" label={TEXT_DEF.text0002}>
                                    <Input style={{ width: "100%" }} />
                                </Form.Item>
                            </div>
                        </div>

                        <div
                            className="col-12"
                            style={{ marginBottom: 15, display: "flex" }}
                        >
                            <div className="col-5">
                                <Form.Item name="dateFrom" label={TEXT_DEF.text0032}>
                                    <DatePicker
                                        placeholder=""
                                        onChange={(e) => onChangeDate(e, "from")}
                                        format={"DD-MM-YYYY"}
                                        style={{ width: "100%" }}
                                        disabledTime={(d) =>
                                            !d ||
                                            d.isSameOrAfter(
                                                dateTo ? moment(dateTo).add(1, "d") : moment()
                                            )
                                        }
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-5">
                                <Form.Item name="dateTo" label={TEXT_DEF.text0033}>
                                    <DatePicker
                                        placeholder=""
                                        onChange={(e) => onChangeDate(e, "to")}
                                        format={"DD-MM-YYYY"}
                                        style={{ width: "100%" }}
                                        disabledTime={(d) =>
                                            !d ||
                                            d.isSameOrBefore(dateFrom ? dateFrom : null) ||
                                            d.isSameOrAfter(moment())
                                        }
                                    />
                                </Form.Item>
                            </div>
                        </div>

                        <div className="payment-search">
                            <Button htmlType="submit" type="primary">
                                {TEXT_DEF.text0031}
                            </Button>
                            <Button
                                style={{ marginLeft: 20 }}
                                onClick={handleDownloadExcel}
                                htmlType="button"
                                type="primary"
                            >
                                {TEXT_DEF.text0050}
                            </Button>
                        </div>
                    </Form>
                </div>

                <Spin spinning={loading} delay={500} size="large">
                    <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
                        <Table
                            key="conversionList"
                            locale={locale}
                            columns={dataColums}
                            dataSource={dataList}
                            pagination={false}
                            bordered
                            style={{ width: "100%" }}
                        />
                    </div>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            marginTop: 15,
                            justifyContent: "flex-end",
                        }}
                    >
                        <Pagination
                            current={page}
                            total={totalRecord}
                            onChange={onChangePage}
                            defaultPageSize={10}
                            showSizeChanger={false}
                            showTotal={showTotal}
                        />
                    </div>
                </Spin>
            </>
        );
    };

    return (
        <div className="col-12">
            {renderHistory()}
        </div>
    );
};

export default GamingHistoryList;
